import script from "./MusicBrainzMetadata.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicBrainzMetadata.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__